import { v4 as uuidv4 } from 'uuid';

import { PromptTemplateSource } from '../ai-agent/types';

export interface AIChatCommandOptions {
  prompt?: string;
  newSession?: boolean;
  autoSend?: boolean;
  template?: PromptTemplateSource;
}

export interface AIChatCommand {
  id: string;
  prompt?: string;
  newSession: boolean;
  autoSend: boolean;
  /** Set when the prompt came from the prompt catalog rather than the user. */
  template?: PromptTemplateSource;
}

export enum AIChatCommandResult {
  Busy = 'busy',
  Deferred = 'deferred',
  Handled = 'handled',
  NotSupported = 'not supported',
  Sent = 'sent',
}

export function createAIChatCommand(
  options: AIChatCommandOptions = {},
): AIChatCommand {
  return {
    id: uuidv4(),
    prompt: typeof options.prompt === 'string' ? options.prompt : undefined,
    newSession: options.newSession === true,
    autoSend: options.autoSend === true,
    ...(options.template && { template: options.template }),
  };
}
